// source: proto/entity/audit.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) { return this; }
  if (typeof window !== 'undefined') { return window; }
  if (typeof global !== 'undefined') { return global; }
  if (typeof self !== 'undefined') { return self; }
  return Function('return this')();
}.call(null));

var google_protobuf_struct_pb = require('google-protobuf/google/protobuf/struct_pb.js');
goog.object.extend(proto, google_protobuf_struct_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
goog.exportSymbol('proto.entity.AuditEvent', null, global);
goog.exportSymbol('proto.entity.AuditEvent.DatabaseAction', null, global);
goog.exportSymbol('proto.entity.AuditEvent.DatabaseAction.Option', null, global);
goog.exportSymbol('proto.entity.AuditEvent.FieldChange', null, global);
goog.exportSymbol('proto.entity.AuditEventColumnFilter', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.AuditEvent = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.AuditEvent, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.AuditEvent.displayName = 'proto.entity.AuditEvent';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.AuditEvent.FieldChange = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.AuditEvent.FieldChange, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.AuditEvent.FieldChange.displayName = 'proto.entity.AuditEvent.FieldChange';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.AuditEvent.DatabaseAction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.AuditEvent.DatabaseAction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.AuditEvent.DatabaseAction.displayName = 'proto.entity.AuditEvent.DatabaseAction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.entity.AuditEventColumnFilter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.entity.AuditEventColumnFilter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.entity.AuditEventColumnFilter.displayName = 'proto.entity.AuditEventColumnFilter';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.AuditEvent.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.AuditEvent.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.AuditEvent} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AuditEvent.toObject = function(includeInstance, msg) {
  var f, obj = {
    eventId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    schemaName: jspb.Message.getFieldWithDefault(msg, 2, ""),
    tableName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    dbUserName: jspb.Message.getFieldWithDefault(msg, 4, ""),
    applicationName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    transactionId: jspb.Message.getFieldWithDefault(msg, 6, 0),
    transactionTime: (f = msg.getTransactionTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    actionTime: (f = msg.getActionTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    action: jspb.Message.getFieldWithDefault(msg, 9, 0),
    actionSqlQuery: jspb.Message.getFieldWithDefault(msg, 10, ""),
    originalFieldsMap: (f = msg.getOriginalFieldsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Value.toObject) : [],
    changedFieldsMap: (f = msg.getChangedFieldsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Value.toObject) : [],
    primaryKeyFieldsMap: (f = msg.getPrimaryKeyFieldsMap()) ? f.toObject(includeInstance, proto.google.protobuf.Value.toObject) : [],
    fieldChangesMap: (f = msg.getFieldChangesMap()) ? f.toObject(includeInstance, proto.entity.AuditEvent.FieldChange.toObject) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.AuditEvent}
 */
proto.entity.AuditEvent.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.AuditEvent;
  return proto.entity.AuditEvent.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.AuditEvent} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.AuditEvent}
 */
proto.entity.AuditEvent.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEventId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setSchemaName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setTableName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDbUserName(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setApplicationName(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTransactionId(value);
      break;
    case 7:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setTransactionTime(value);
      break;
    case 8:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setActionTime(value);
      break;
    case 9:
      var value = /** @type {!proto.entity.AuditEvent.DatabaseAction.Option} */ (reader.readEnum());
      msg.setAction(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setActionSqlQuery(value);
      break;
    case 11:
      var value = msg.getOriginalFieldsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Value.deserializeBinaryFromReader, "", new proto.google.protobuf.Value());
         });
      break;
    case 12:
      var value = msg.getChangedFieldsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Value.deserializeBinaryFromReader, "", new proto.google.protobuf.Value());
         });
      break;
    case 13:
      var value = msg.getPrimaryKeyFieldsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.google.protobuf.Value.deserializeBinaryFromReader, "", new proto.google.protobuf.Value());
         });
      break;
    case 14:
      var value = msg.getFieldChangesMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readMessage, proto.entity.AuditEvent.FieldChange.deserializeBinaryFromReader, "", new proto.entity.AuditEvent.FieldChange());
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.AuditEvent.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.AuditEvent.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.AuditEvent} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AuditEvent.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEventId();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSchemaName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTableName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDbUserName();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getApplicationName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getTransactionId();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getTransactionTime();
  if (f != null) {
    writer.writeMessage(
      7,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getActionTime();
  if (f != null) {
    writer.writeMessage(
      8,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getAction();
  if (f !== 0.0) {
    writer.writeEnum(
      9,
      f
    );
  }
  f = message.getActionSqlQuery();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getOriginalFieldsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(11, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Value.serializeBinaryToWriter);
  }
  f = message.getChangedFieldsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(12, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Value.serializeBinaryToWriter);
  }
  f = message.getPrimaryKeyFieldsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(13, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.google.protobuf.Value.serializeBinaryToWriter);
  }
  f = message.getFieldChangesMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(14, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeMessage, proto.entity.AuditEvent.FieldChange.serializeBinaryToWriter);
  }
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.AuditEvent.FieldChange.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.AuditEvent.FieldChange.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.AuditEvent.FieldChange} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AuditEvent.FieldChange.toObject = function(includeInstance, msg) {
  var f, obj = {
    oldValue: (f = msg.getOldValue()) && google_protobuf_struct_pb.Value.toObject(includeInstance, f),
    newValue: (f = msg.getNewValue()) && google_protobuf_struct_pb.Value.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.AuditEvent.FieldChange}
 */
proto.entity.AuditEvent.FieldChange.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.AuditEvent.FieldChange;
  return proto.entity.AuditEvent.FieldChange.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.AuditEvent.FieldChange} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.AuditEvent.FieldChange}
 */
proto.entity.AuditEvent.FieldChange.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new google_protobuf_struct_pb.Value;
      reader.readMessage(value,google_protobuf_struct_pb.Value.deserializeBinaryFromReader);
      msg.setOldValue(value);
      break;
    case 2:
      var value = new google_protobuf_struct_pb.Value;
      reader.readMessage(value,google_protobuf_struct_pb.Value.deserializeBinaryFromReader);
      msg.setNewValue(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.AuditEvent.FieldChange.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.AuditEvent.FieldChange.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.AuditEvent.FieldChange} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AuditEvent.FieldChange.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getOldValue();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      google_protobuf_struct_pb.Value.serializeBinaryToWriter
    );
  }
  f = message.getNewValue();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_struct_pb.Value.serializeBinaryToWriter
    );
  }
};


/**
 * optional google.protobuf.Value old_value = 1;
 * @return {?proto.google.protobuf.Value}
 */
proto.entity.AuditEvent.FieldChange.prototype.getOldValue = function() {
  return /** @type{?proto.google.protobuf.Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Value, 1));
};


/**
 * @param {?proto.google.protobuf.Value|undefined} value
 * @return {!proto.entity.AuditEvent.FieldChange} returns this
*/
proto.entity.AuditEvent.FieldChange.prototype.setOldValue = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.AuditEvent.FieldChange} returns this
 */
proto.entity.AuditEvent.FieldChange.prototype.clearOldValue = function() {
  return this.setOldValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.AuditEvent.FieldChange.prototype.hasOldValue = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional google.protobuf.Value new_value = 2;
 * @return {?proto.google.protobuf.Value}
 */
proto.entity.AuditEvent.FieldChange.prototype.getNewValue = function() {
  return /** @type{?proto.google.protobuf.Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Value, 2));
};


/**
 * @param {?proto.google.protobuf.Value|undefined} value
 * @return {!proto.entity.AuditEvent.FieldChange} returns this
*/
proto.entity.AuditEvent.FieldChange.prototype.setNewValue = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.AuditEvent.FieldChange} returns this
 */
proto.entity.AuditEvent.FieldChange.prototype.clearNewValue = function() {
  return this.setNewValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.AuditEvent.FieldChange.prototype.hasNewValue = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.AuditEvent.DatabaseAction.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.AuditEvent.DatabaseAction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.AuditEvent.DatabaseAction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AuditEvent.DatabaseAction.toObject = function(includeInstance, msg) {
  var f, obj = {

  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.AuditEvent.DatabaseAction}
 */
proto.entity.AuditEvent.DatabaseAction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.AuditEvent.DatabaseAction;
  return proto.entity.AuditEvent.DatabaseAction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.AuditEvent.DatabaseAction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.AuditEvent.DatabaseAction}
 */
proto.entity.AuditEvent.DatabaseAction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.AuditEvent.DatabaseAction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.AuditEvent.DatabaseAction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.AuditEvent.DatabaseAction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AuditEvent.DatabaseAction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
};


/**
 * @enum {number}
 */
proto.entity.AuditEvent.DatabaseAction.Option = {
  UNSPECIFIED: 0,
  UNKNOWN: 1,
  INSERT: 2,
  UPDATE: 3,
  DELETE: 4,
  TRUNCATED: 5
};

/**
 * optional int64 event_id = 1;
 * @return {number}
 */
proto.entity.AuditEvent.prototype.getEventId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.AuditEvent} returns this
 */
proto.entity.AuditEvent.prototype.setEventId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string schema_name = 2;
 * @return {string}
 */
proto.entity.AuditEvent.prototype.getSchemaName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AuditEvent} returns this
 */
proto.entity.AuditEvent.prototype.setSchemaName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string table_name = 3;
 * @return {string}
 */
proto.entity.AuditEvent.prototype.getTableName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AuditEvent} returns this
 */
proto.entity.AuditEvent.prototype.setTableName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string db_user_name = 4;
 * @return {string}
 */
proto.entity.AuditEvent.prototype.getDbUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AuditEvent} returns this
 */
proto.entity.AuditEvent.prototype.setDbUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string application_name = 5;
 * @return {string}
 */
proto.entity.AuditEvent.prototype.getApplicationName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AuditEvent} returns this
 */
proto.entity.AuditEvent.prototype.setApplicationName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional int64 transaction_id = 6;
 * @return {number}
 */
proto.entity.AuditEvent.prototype.getTransactionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.entity.AuditEvent} returns this
 */
proto.entity.AuditEvent.prototype.setTransactionId = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional google.protobuf.Timestamp transaction_time = 7;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.entity.AuditEvent.prototype.getTransactionTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 7));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.entity.AuditEvent} returns this
*/
proto.entity.AuditEvent.prototype.setTransactionTime = function(value) {
  return jspb.Message.setWrapperField(this, 7, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.AuditEvent} returns this
 */
proto.entity.AuditEvent.prototype.clearTransactionTime = function() {
  return this.setTransactionTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.AuditEvent.prototype.hasTransactionTime = function() {
  return jspb.Message.getField(this, 7) != null;
};


/**
 * optional google.protobuf.Timestamp action_time = 8;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.entity.AuditEvent.prototype.getActionTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 8));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.entity.AuditEvent} returns this
*/
proto.entity.AuditEvent.prototype.setActionTime = function(value) {
  return jspb.Message.setWrapperField(this, 8, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.AuditEvent} returns this
 */
proto.entity.AuditEvent.prototype.clearActionTime = function() {
  return this.setActionTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.AuditEvent.prototype.hasActionTime = function() {
  return jspb.Message.getField(this, 8) != null;
};


/**
 * optional DatabaseAction.Option action = 9;
 * @return {!proto.entity.AuditEvent.DatabaseAction.Option}
 */
proto.entity.AuditEvent.prototype.getAction = function() {
  return /** @type {!proto.entity.AuditEvent.DatabaseAction.Option} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {!proto.entity.AuditEvent.DatabaseAction.Option} value
 * @return {!proto.entity.AuditEvent} returns this
 */
proto.entity.AuditEvent.prototype.setAction = function(value) {
  return jspb.Message.setProto3EnumField(this, 9, value);
};


/**
 * optional string action_sql_query = 10;
 * @return {string}
 */
proto.entity.AuditEvent.prototype.getActionSqlQuery = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AuditEvent} returns this
 */
proto.entity.AuditEvent.prototype.setActionSqlQuery = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * map<string, google.protobuf.Value> original_fields = 11;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Value>}
 */
proto.entity.AuditEvent.prototype.getOriginalFieldsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Value>} */ (
      jspb.Message.getMapField(this, 11, opt_noLazyCreate,
      proto.google.protobuf.Value));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.entity.AuditEvent} returns this
 */
proto.entity.AuditEvent.prototype.clearOriginalFieldsMap = function() {
  this.getOriginalFieldsMap().clear();
  return this;};


/**
 * map<string, google.protobuf.Value> changed_fields = 12;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Value>}
 */
proto.entity.AuditEvent.prototype.getChangedFieldsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Value>} */ (
      jspb.Message.getMapField(this, 12, opt_noLazyCreate,
      proto.google.protobuf.Value));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.entity.AuditEvent} returns this
 */
proto.entity.AuditEvent.prototype.clearChangedFieldsMap = function() {
  this.getChangedFieldsMap().clear();
  return this;};


/**
 * map<string, google.protobuf.Value> primary_key_fields = 13;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.google.protobuf.Value>}
 */
proto.entity.AuditEvent.prototype.getPrimaryKeyFieldsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.google.protobuf.Value>} */ (
      jspb.Message.getMapField(this, 13, opt_noLazyCreate,
      proto.google.protobuf.Value));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.entity.AuditEvent} returns this
 */
proto.entity.AuditEvent.prototype.clearPrimaryKeyFieldsMap = function() {
  this.getPrimaryKeyFieldsMap().clear();
  return this;};


/**
 * map<string, FieldChange> field_changes = 14;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,!proto.entity.AuditEvent.FieldChange>}
 */
proto.entity.AuditEvent.prototype.getFieldChangesMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,!proto.entity.AuditEvent.FieldChange>} */ (
      jspb.Message.getMapField(this, 14, opt_noLazyCreate,
      proto.entity.AuditEvent.FieldChange));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.entity.AuditEvent} returns this
 */
proto.entity.AuditEvent.prototype.clearFieldChangesMap = function() {
  this.getFieldChangesMap().clear();
  return this;};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.entity.AuditEventColumnFilter.prototype.toObject = function(opt_includeInstance) {
  return proto.entity.AuditEventColumnFilter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.entity.AuditEventColumnFilter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AuditEventColumnFilter.toObject = function(includeInstance, msg) {
  var f, obj = {
    columnName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    columnValue: (f = msg.getColumnValue()) && google_protobuf_struct_pb.Value.toObject(includeInstance, f),
    valueStringContains: jspb.Message.getFieldWithDefault(msg, 3, ""),
    orColumnFilter: (f = msg.getOrColumnFilter()) && proto.entity.AuditEventColumnFilter.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.entity.AuditEventColumnFilter}
 */
proto.entity.AuditEventColumnFilter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.entity.AuditEventColumnFilter;
  return proto.entity.AuditEventColumnFilter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.entity.AuditEventColumnFilter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.entity.AuditEventColumnFilter}
 */
proto.entity.AuditEventColumnFilter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setColumnName(value);
      break;
    case 2:
      var value = new google_protobuf_struct_pb.Value;
      reader.readMessage(value,google_protobuf_struct_pb.Value.deserializeBinaryFromReader);
      msg.setColumnValue(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setValueStringContains(value);
      break;
    case 4:
      var value = new proto.entity.AuditEventColumnFilter;
      reader.readMessage(value,proto.entity.AuditEventColumnFilter.deserializeBinaryFromReader);
      msg.setOrColumnFilter(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.entity.AuditEventColumnFilter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.entity.AuditEventColumnFilter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.entity.AuditEventColumnFilter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.entity.AuditEventColumnFilter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getColumnName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getColumnValue();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_struct_pb.Value.serializeBinaryToWriter
    );
  }
  f = message.getValueStringContains();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getOrColumnFilter();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      proto.entity.AuditEventColumnFilter.serializeBinaryToWriter
    );
  }
};


/**
 * optional string column_name = 1;
 * @return {string}
 */
proto.entity.AuditEventColumnFilter.prototype.getColumnName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AuditEventColumnFilter} returns this
 */
proto.entity.AuditEventColumnFilter.prototype.setColumnName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Value column_value = 2;
 * @return {?proto.google.protobuf.Value}
 */
proto.entity.AuditEventColumnFilter.prototype.getColumnValue = function() {
  return /** @type{?proto.google.protobuf.Value} */ (
    jspb.Message.getWrapperField(this, google_protobuf_struct_pb.Value, 2));
};


/**
 * @param {?proto.google.protobuf.Value|undefined} value
 * @return {!proto.entity.AuditEventColumnFilter} returns this
*/
proto.entity.AuditEventColumnFilter.prototype.setColumnValue = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.AuditEventColumnFilter} returns this
 */
proto.entity.AuditEventColumnFilter.prototype.clearColumnValue = function() {
  return this.setColumnValue(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.AuditEventColumnFilter.prototype.hasColumnValue = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional string value_string_contains = 3;
 * @return {string}
 */
proto.entity.AuditEventColumnFilter.prototype.getValueStringContains = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.entity.AuditEventColumnFilter} returns this
 */
proto.entity.AuditEventColumnFilter.prototype.setValueStringContains = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional AuditEventColumnFilter or_column_filter = 4;
 * @return {?proto.entity.AuditEventColumnFilter}
 */
proto.entity.AuditEventColumnFilter.prototype.getOrColumnFilter = function() {
  return /** @type{?proto.entity.AuditEventColumnFilter} */ (
    jspb.Message.getWrapperField(this, proto.entity.AuditEventColumnFilter, 4));
};


/**
 * @param {?proto.entity.AuditEventColumnFilter|undefined} value
 * @return {!proto.entity.AuditEventColumnFilter} returns this
*/
proto.entity.AuditEventColumnFilter.prototype.setOrColumnFilter = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.entity.AuditEventColumnFilter} returns this
 */
proto.entity.AuditEventColumnFilter.prototype.clearOrColumnFilter = function() {
  return this.setOrColumnFilter(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.entity.AuditEventColumnFilter.prototype.hasOrColumnFilter = function() {
  return jspb.Message.getField(this, 4) != null;
};


goog.object.extend(exports, proto.entity);
